module.exports = __webpack_public_path__ + "img/icon_ai_report_icon_1.0c711a7b.png";